export default __webpack_public_path__ + "static/media/tdh-whole-person-care.e8b19f30.png";